module.exports = __webpack_public_path__ + "img/cartaz-mobile.6d89a0f4.jpg";